import React from 'react';
import { formatMoney } from 'utils/formatMoney';

const Item = ({ data }) => (
  <tr>
    <td>
#
      {data.ID}
    </td>
    <td>
      {data.date_added}
    </td>
    <td>
      {formatMoney(data.fund_user)}
    </td>
  </tr>
);

export default Item;



// WEBPACK FOOTER //
// ./src/pages/Transactions/item.js